<template>
<div>
    <label for="Linea"><strong>LINEA</strong></label>
        <select id='line' @change="$emit('update',lineId)" class="form-control" v-model="lineId">
         <option v-if="optionBase==true" value="0"> -- TUTTE  -- </option>   
        <option v-for="(item,index) in items" :value="item.lineId" :key="index">{{item.line}}</option>        
        </select>  
</div>

</template>
<script>
import api             from "@/api";

export default {
  props : ['isActive','optionBase','required','supplierId','Id'], 
  components: {},
  data() {
    return {

      lineId             : this.Id ? this.Id : 0,
      items              : [],
      spinner            : false
           
    };
  },
  
  mounted: function() {
  
  },
  created: function() {
      if(this.supplierId)
      {
        this.getData()
      }
  },
  methods: 
  {
   
    async getData()
    {
            
     var sp   = {'sp'         : 'spSupplierLineSelect'}
     var data = {'supplierId' : this.supplierId}
     var json = Object.assign(data, sp)
     
     

     await api.post(json).then(res => {
          
      

          if(res.status==200)
            {
              this.items = res.data.recordsets[0]                            
            }
           else if(res.status==500)
           {
                console.log(res.data)

                
                    
           } 
           else
            {
                console.log('Network Error.')                  
                 
            } 
          

          }).catch(err => {
              
              console.log(err.message)    

              
          }).finally(() => {
          this.spinner = false
        });
 




     
    },
  
    
    
  
}

}
</script>
<style scoped>

</style>